import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerCategories = categories.slice(0, 8);
const footerCategories2 = categories.slice(8);

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleGoToCategories = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById('categories');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('categories');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 400);
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 text-foreground-950 no-underline mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg"></i>
              </div>
              <span className="text-lg font-bold tracking-tight font-heading">
                Itaobuy<span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              A structured product intelligence system helping shoppers compare, analyze, and make smarter purchasing decisions with data-driven spreadsheets.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              Visit Main Platform
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Home</Link>
              </li>
              <li>
                <a href="#categories" onClick={handleGoToCategories} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Shopping Guide</a>
              </li>
              <li>
                <Link to="/article/what-is-itaobuyspreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Complete Guide</Link>
              </li>
              <li>
                <Link to="/article/itaobuyspreadsheet-safety-transparency" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Safety Report</Link>
              </li>
              <li>
                <Link to="/article/smart-shopping-spreadsheets-2026" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Shopping Trends 2026</Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Itaobuy Sheet</a>
              </li>
            </ul>
          </div>

          {/* Categories 1 */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">
              Product Categories
            </h4>
            <ul className="space-y-2">
              {footerCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories 2 */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">
              More Categories
            </h4>
            <ul className="space-y-2">
              {footerCategories2.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} itaobuy.bond. This site provides structured product data for research purposes only. We are not a seller and do not process payments.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Privacy</Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Disclaimer</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}